export type UserTypeValue = 'CHURCH' | 'MINISTER' | 'MEMBER' | '';

export type SelectableUserType = 'CHURCH' | 'MINISTER' | 'MEMBER';

export const USER_TYPE_LABELS: Record<SelectableUserType, string> = {
  CHURCH: '교회 담당자',
  MINISTER: '사역자',
  MEMBER: '일반성도',
};

export const USER_TYPE_ROLE_HINTS: Record<SelectableUserType, string> = {
  CHURCH: '구인을 하는',
  MINISTER: '구직을 하는',
  MEMBER: '교회 성도',
};

export function getUserTypeLabel(value: unknown): string {
  const normalized = normalizeUserType(value);
  if (!normalized) return '';
  return USER_TYPE_LABELS[normalized as SelectableUserType] || normalized;
}

export function isUserTypeUnset(value: unknown): boolean {
  return !String(value || '').trim();
}

export function normalizeUserType(value: unknown): UserTypeValue {
  const upper = String(value || '').trim().toUpperCase();
  if (upper === 'MINISTER' || upper === 'MEMBER' || upper === 'CHURCH') {
    return upper;
  }
  return '';
}

export function isMemberUser(userType: unknown): boolean {
  return normalizeUserType(userType) === 'MEMBER';
}

export function mapLoginUserData(data: Record<string, unknown>) {
  const userType = normalizeUserType(data.userType ?? data.user_type);
  return {
    userAccount: String(data.userAccount || ''),
    userNickName: String(data.userNickName || ''),
    userChurch: String(data.userChurch || ''),
    userSort: String(data.userSort || ''),
    userDetail: String(data.userDetail || ''),
    grade: String(data.grade || ''),
    userType,
    authInstitution: String(data.authInstitution || ''),
    authChurch: String(data.authChurch || ''),
    authDepartment: String(data.authDepartment || ''),
    authGroup: String(data.authGroup || ''),
  };
}

export function needsUserTypeSelection(data: Record<string, unknown>): boolean {
  return (
    data.needsUserTypeSelection === true ||
    (isUserTypeUnset(data.userType) && isUserTypeUnset(data.user_type))
  );
}

export const USER_TYPE_ONBOARDING_PATH = '/login/usertype';
export const SIGNUP_USER_TYPE_KEY = 'signupUserType';

export function getSignupUserType(): UserTypeValue {
  return normalizeUserType(sessionStorage.getItem(SIGNUP_USER_TYPE_KEY));
}

export function setSignupUserType(type: SelectableUserType): void {
  sessionStorage.setItem(SIGNUP_USER_TYPE_KEY, type);
}

export function clearSignupUserType(): void {
  sessionStorage.removeItem(SIGNUP_USER_TYPE_KEY);
}
